// The single rollout gate for RFC-1371 team accounts.
//
// `teams_enabled` is declared `client_exposed=True` in the backend flag
// registry and reaches the browser through the same GET /config/flags snapshot
// every other client flag uses. This wrapper exists so the flag KEY is written
// once: the console has no typed flag registry, so `useBooleanFlagValue` takes
// a bare string and a typo resolves silently to the caller default forever.
//
// The default is `false`, matching the registry. `useBooleanFlagValue`
// collapses "snapshot not loaded yet" into that default, which is the right
// behaviour for every teams surface: they all only ADD UI, so the worst case is
// that a team switcher appears a beat after first paint. Nothing here redirects
// or guards a route, so none of it needs the `useClientFlags().isLoading` wait
// that the checkout guard needs.

import { useBooleanFlagValue } from '../../hooks/useBooleanFlagValue'

export const TEAMS_FLAG_KEY = 'teams_enabled'

export function useTeamsEnabled(): boolean {
  return useBooleanFlagValue(TEAMS_FLAG_KEY, false)
}
